import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIUAFeatureTable from 'ui-addon-upgrades/featureTable/FeatureTable';
import FeatureTableColTag from '../../../components/feature-table/FeatureTableColTag';
import { useShowStarterCustomerPlatformUpsellCard } from '../../../hooks/upsell/useStarterUpsell';
import { SingleSkeletonLoader } from '../../components/SingleSkeletonLoader';
import { FeatureTableHeaderCellContent } from '../../components/feature-table/FeatureTableHeaderCellContent';
import { PriceByProductApiName } from '../../containers/PriceByProductApiName';
import { PurchaseMotionsByProductApiNameAndLocation } from '../../containers/PurchaseMotionsByProductApiNameAndLocation';
import { useBadges } from '../../hooks/badges/useBadges';
import { useFormattedFeatureTableBodyData } from '../../hooks/features/useFormattedFeatureTableBodyData';
import { createFeatureTableHeaderTrackingData } from '../../utils/trackingData';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentHubFeatureTable = () => {
  var _badges$starterApiNam, _badges$cmsHubProfe, _badges$cmsHubEnter;
  const {
    showStarterCustomerPlatformUpsellCard,
    upsellStarterApiName,
    loading
  } = useShowStarterCustomerPlatformUpsellCard();
  const starterApiNameForBadges = showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'cms-hub-starter';
  const badgeApiNames = [starterApiNameForBadges, 'cms-hub-professional', 'cms-hub-enterprise'];
  const {
    badges
  } = useBadges({
    productApiNames: badgeApiNames,
    skipOverride: loading
  });
  const formattedFeatureTableBodyData = useFormattedFeatureTableBodyData({
    productApiNames: ['cms-hub-starter', 'cms-hub-professional', 'cms-hub-enterprise'],
    skuCategoryName: 'CMS_HUB_PRODUCTS'
  });
  if (formattedFeatureTableBodyData.error) {
    return null;
  }
  if (formattedFeatureTableBodyData.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 250,
      width: "100%"
    });
  }

  // If the fetch for data is successful and there are no features
  // don't render the table because the purchase motions are identical
  // to that of the merch card
  if (formattedFeatureTableBodyData.data.sectionData.all.features.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIUAFeatureTable, {
    canViewNewSeats: true,
    headerData: {
      'cms-hub-starter': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "cms-hub-starter",
            badgeName: badges === null || badges === void 0 || (_badges$starterApiNam = badges[starterApiNameForBadges]) === null || _badges$starterApiNam === void 0 ? void 0 : _badges$starterApiNam.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.starterCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-starter"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'cms-hub-starter',
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData(showStarterCustomerPlatformUpsellCard ? upsellStarterApiName : 'cms-hub-starter', 'content')
          })
        })
      },
      'cms-hub-professional': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "cms-hub-professional",
            badgeName: badges === null || badges === void 0 || (_badges$cmsHubProfe = badges['cms-hub-professional']) === null || _badges$cmsHubProfe === void 0 ? void 0 : _badges$cmsHubProfe.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.professionalCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-professional"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "cms-hub-professional",
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData('cms-hub-professional', 'content')
          })
        })
      },
      'cms-hub-enterprise': {
        Content: /*#__PURE__*/_jsx(FeatureTableHeaderCellContent, {
          Badge: /*#__PURE__*/_jsx(FeatureTableColTag, {
            apiName: "cms-hub-enterprise",
            badgeName: badges === null || badges === void 0 || (_badges$cmsHubEnter = badges['cms-hub-enterprise']) === null || _badges$cmsHubEnter === void 0 ? void 0 : _badges$cmsHubEnter.badgeName
          }),
          ProductDisplayName: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.titleDisplay.enterpriseCard"
          }),
          Price: /*#__PURE__*/_jsx(PriceByProductApiName, {
            productApiName: "cms-hub-enterprise"
          }),
          PurchaseMotion: /*#__PURE__*/_jsx(PurchaseMotionsByProductApiNameAndLocation, {
            productApiName: "cms-hub-enterprise",
            location: "MERCH_CARD",
            displayCount: 1,
            trackingData: createFeatureTableHeaderTrackingData('cms-hub-enterprise', 'content')
          })
        })
      }
    },
    bodyData: formattedFeatureTableBodyData.data,
    isInbound25PricingPage: true
  });
};